import * as Yup from "yup";

export const VehicleSchema = Yup.object({

    model: Yup.string().required("Please Select Model"),
    reg_number: Yup.string().required("Enter Registration Number"),
    reg_date: Yup.string().required("Select Registration Date"),
    vehicle_img: Yup.mixed().required("Banner Image"),
    rc_doc: Yup.mixed().required("Banner Image"),
    latitude: Yup.string().required("Enter Latitude"),
    longitude: Yup.string().required("Enter Longitude "),
    status: Yup.string().required("Select Status"),


});